import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import pkg from 'package'
import config from './config'
import menu from '../router/menu'

Vue.use(Vuex)

const state = {
  pkg,
  config,
  menu,
  count: 0
}

const mutations = {
  INCREMENT (state) {
    state.count++
  },
  SIDEBAR (state, status = true) {
    state.config.sidebar = status
  },
  TOKEN (state, token) {
    state.config.token = token
  },
  USER (state, user) {
    state.config.user = user
  },
  LOGGED (state, logged) {
    state.config.logged = logged
  },
  NOTIFICATIONS (state, notifications) {
    state.config.notifications = notifications
  },
  COUNTERS (state, counters) {
    state.config.counters = counters
  },
  NOTIFICATION (state, notification) {
    state.config.notifications.push(notification)
  },
  ALERT (state, show) {
    state.config.show_alert = show
  },
  VERSION (state, version) {
    state.config.version = version
  },
  READ_NOTIFICATION (state, id) {
    for (var i = 0; i < state.config.notifications.length; i++) {
      if (state.config.notifications[i].id === id) {
        state.config.notifications.splice(i, 1)
      }
    }
  }
}

const actions = {
  // Sidebar: show, hide, toggle
  SHOW_SIDEBAR ({commit}) {
    commit('SIDEBAR', true)
  },
  HIDE_SIDEBAR ({commit}) {
    commit('SIDEBAR', false)
  },
  TOGGLE_SIDEBAR ({commit, state}) {
    commit('SIDEBAR', !state.config.sidebar)
  },
  SET_TOKEN ({commit}, token) {
    commit('TOKEN', token)
  },
  SET_USER ({commit}, user) {
    commit('USER', user)
  },
  SET_LOGGED ({commit}, logged) {
    commit('LOGGED', logged)
  },
  SET_NOTIFICATIONS ({commit}, notifications) {
    commit('NOTIFICATIONS', notifications)
  },
  SET_COUNTERS ({commit}, counters) {
    commit('COUNTERS', counters)
  },
  SET_ALERT ({commit}, show) {
    commit('ALERT', show)
  },
  SET_VERSION ({commit}, version) {
    commit('VERSION', version)
  },
  ADD_NOTIFICATION ({commit}, notification) {
    commit('NOTIFICATION', notification)
  },
  READ_NOTIFICATION ({commit}, notification) {
    commit('READ_NOTIFICATION', notification)
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js